module.exports = __webpack_public_path__ + "static/erevalue-11e0a49893a7d323684f815216acd0ab.jpg";